<template>
  <div class="app-mnp-in">
    <b-form-group class="mnp-type-group">
      <b-form-radio-group v-model="mnpData_.portingType">
        <b-form-radio value="CONTRACT_END">
          <slot name="ContractEndLabel"></slot>
          <slot name="ContractEndText"></slot>
          <slot v-if="mnpData_.portingType==='CONTRACT_END'" name="ContractEndDetails"></slot>
        </b-form-radio>
        <b-form-radio value="AS_SOON_AS_POSSIBLE">
          <slot name="ASAPLabel"></slot>
          <slot name="ASAPText"></slot>
          <slot v-if="mnpData_.portingType==='AS_SOON_AS_POSSIBLE'" name="ASAPDetails"></slot>
        </b-form-radio>
      </b-form-radio-group>
    </b-form-group>
    <b-form-group class="mnp-checkbox-group">
      <b-form-checkbox
        id="mnp-terms-checkbox"
        v-model="mnpData_.terms"
        name="mnp-terms-checkbox"
      >
        <slot name="termsCheckboxLabel"></slot>
        <slot name="termsCheckboxText"></slot>
      </b-form-checkbox>
    </b-form-group>
    <b-form-group class="porting-msisdn-group">
      <b-row>
        <b-col md="4" lg="3" sm="12">
          <label class="mandatory d-inline-block"><slot name="portingMsisdnLabel">Rufnummer *</slot></label>
        </b-col>
        <b-col md="6" lg="5" sm="12">
          <b-form-input
            name="portingMsisdn"
            type="text"
            required
            v-model="mnpData_.msisdn"
            @input="$v.mnpData.msisdn.$touch"
            :state="isValid('msisdn', 'mnpData')"
          ></b-form-input>
        </b-col>
      </b-row>
    </b-form-group>
    <b-form-group class="mnp-provider-group">
      <b-row>
        <b-col md="4" lg="3" sm="12">
          <label class="mandatory d-inline-block"><slot name="providerLabel">bisheriger Anbieter *</slot></label>
        </b-col>
        <b-col md="6" lg="5" sm="12">
          <b-form-select
            name="portingMsisdn"
            type="text"
            required
            :options="providerOptions"
            v-model="mnpData_.provider"
          ></b-form-select>
        </b-col>
      </b-row>
    </b-form-group>
  </div>
</template>

<script>

import syncProperty from '@/mixins/syncProperty'
import { helpers, required } from 'vuelidate/lib/validators'
import isValid from '../../../../../mixins/isValid'
import { validationMixin } from 'vuelidate'

const isPhoneNumber = helpers.regex('phoneNumber', /^[+]?[0-9]*$/)

export default {
  name: 'EnterMnpInData',
  computed: {
    providerOptions () {
      return this.mnpProviders.map((provider) => {
        return {
          text: provider.name,
          value: {
            providerKey: provider.key,
            networkKey: provider.networks.length > 0 ? provider.networks[0].key : null
          }
        }
      })
    }
  },
  watch: {
    '$v.$invalid': {
      immediate: true,
      handler: function (newValue) {
        this.$emit('update:invalid', newValue)
      }
    }
  },
  validations () {
    return {
      mnpData: {
        msisdn: {
          required,
          isPhoneNumber
        },
        provider: {
          providerKey: {
            required
          },
          networkKey: {
            required
          }
        },
        terms: {
          accepted: val => val === true
        }
      }
    }
  },
  props: {
    mnpProviders: {
      type: Array,
      default: () => []
    },
    mnpData: {
      type: Object
    }
  },
  mixins: [
    syncProperty('mnpData', 'mnpData_'),
    isValid,
    validationMixin
  ]
}
</script>
